import { alpha } from '@mui/material/styles';

/**
 * Banding for the biweekly sheet, derived from the app theme.
 *
 * The source spreadsheet banded its sections in green with a blue block for the
 * supervisor's half. Here those roles map onto the theme's own two colours —
 * `primary` for the employee's sections, `secondary` for the supervisor's — so
 * the report restyles with the rest of the app instead of carrying its own
 * palette. Tints are alpha over the page background, which keeps the default
 * text colour legible in both light and dark mode.
 */
export const sheetTone = (theme, tone = 'employee') => {
  const color = tone === 'supervisor'
    ? theme.palette.secondary.main
    : theme.palette.primary.main;
  const dark = theme.palette.mode === 'dark';

  return {
    // Section header bar.
    band: alpha(color, dark ? 0.34 : 0.18),
    // Table head row — one step lighter, so a table under a band reads as nested.
    header: alpha(color, dark ? 0.22 : 0.1),
    border: alpha(color, dark ? 0.45 : 0.32),
  };
};
